<template>
  <div>
    <GlobalHead />
    <div class="top" >
      <div class="title">
        <div>
          <h1 class="bigWord">{{ title }}</h1>
          <h4 class="smallWord">{{ tag }}</h4>
        </div>
        <div style="cursor: pointer;" @click="setUpClick">
          <img width="56px;" src="../../../assets/IconRetUp.svg" alt="">
        </div>
      </div>
    </div>
    <div class="swiperBox" style="margin-top: 20px">
      <a-breadcrumb separator=">" style="margin-bottom: 30px;">
        <a-breadcrumb-item>当前位置</a-breadcrumb-item>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>个人中心</a-breadcrumb-item>
        <a-breadcrumb-item style="color: #333333;">我的材料库</a-breadcrumb-item>
      </a-breadcrumb>
      <div style="margin-top: 100px;" v-if="selected === 'off'">
        <div class="iconNoOpen">
          <img src="@/assets/IconNoOpen.png" alt="">
        </div>
        <div class="noOpenTitle">尚未开启“我的材料库”</div>
        <div class="noOpenDescript">材料库开启后系统将会暂存您上传的材料，在事项申报时可以快速选择</div>
        <div class="openMaterialBtn" @click="openMaterial">开启我的材料库</div>
      </div>
      <!-- 材料列表页面 -->
      <material-list ref="materialList" v-if="selected === 'on'"></material-list>
      <!-- 配置开关弹窗 -->
      <set-up-modal ref="setUpModal" @getState="getState"></set-up-modal>
    </div>
    <!-- <GlobalFoot /> -->
  </div>
</template>
<script>
// import { jiopAPI } from '@/api/jiopweb/jiop'
import GlobalHead from '@/views/layout/globalHead.vue'
// import GlobalFoot from '@/views/layout/globalFood.vue'
import IconCopy from '@ant-design/icons/svg/outline/copy.svg?inline'
import MaterialList from './MaterialList.vue'
import SetUpModal from './SetUpModal.vue'
export default {
  name: 'Ucenter',
  components: {
    GlobalHead,
    // GlobalFoot,
    MaterialList,
    SetUpModal
  },
  data () {
    return {
      selected: 'on',
      IconCopy,
      title: '我的材料库',
      tag: '系统暂存您上传的材料，用于您在事项申报时快速选择，系统最多可以储存50个材料',
      userId: ''
    }
  },
  created () {
    if (sessionStorage.getItem('JiopUserInfo')) {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        const userParams = JSON.parse(userInfo.desensitizeUser)
        this.userId = userParams.uid
      }
    } else {
      this.$message.warning('您还未登录！')
      return false
    }
  },
  methods: {
    openMaterial () {
      const _this = this
      this.$confirm({
        title: '开启我的材料库',
        content: h => <div>请确认是否开启我的材料库？</div>,
        onOk () {
          _this.$refs.setUpModal.checkClick('on')
          _this.$refs.setUpModal.confirm('on')
        },
        onCancel () {
          console.log('Cancel')
        },
        class: 'test'
      })
    },
    setUpClick () {
      this.$refs.setUpModal.open()
    },
    getList () {
      this.$refs.materialList.init()
    },
    getState (value) {
      this.selected = value
    }
  }
}
</script>
<style lang="less" scoped>
.top{
  width: 1920px;
  margin: auto;
  background:url(../../../assets/jiopweb3.0.0/publicBelt2.png) repeat-y
}
.title{
  width:1200px;
  margin: auto;
  padding: 68px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bigWord{
  font-size: 36px;
  color: white;
}
.smallWord{
  font-size: 16px;
  color: white;
}
.swiperBox {
  // box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  width: 1200px;
  // height: 120px;
  background: #ffffff;
  margin: auto;
}
.text-1{
// width: 303px;
height: 20px;

font-size: 14px;
color: #999999;
letter-spacing: 0;
font-weight: 400;
}
.text-2{
 width: 100%;
height: 25px;

font-size: 18px;
color: #333333;
letter-spacing: 0;
font-weight: 500;
white-space: nowrap;
text-overflow: ellipsis;
overflow: hidden;
}
.text-3{
// width: 72px;
height: 33px;

font-size: 24px;
color: #333333;
letter-spacing: 0;
font-weight: 500;
}
/deep/ .only.ant-btn {
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 1px solid transparent;
    cursor: pointer;
    user-select: none;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    height: 32px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 20px;
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
}
/deep/ .bu.ant-btn-primary {
    color: #fff;
    border-radius: 20px;
    background-color: #F5222D;
    border-color: #F5222D;
}
.noOpenTitle {
  font-size: 20px;
  color: #333333;
  text-align: center;
  line-height: 28px;
  font-weight: 500;
  margin-top: 24px;
}
.noOpenDescript {
  font-size: 14px;
  color: #666666;
  text-align: center;
  line-height: 22px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 30px;
}
.openMaterialBtn {
  cursor: pointer;
  background: #1677FF;
  color: white;
  border-radius: 2px;
  height: 40px;
  width: 134px;
  line-height: 40px;
  text-align: center;
  margin: auto;
  margin-bottom: 163px;
}
.iconNoOpen {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: auto;
  background-color: #1677FF;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
